export default "__VITE_ASSET__Cw$vWuiB__"